import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-file-manager-alert',
  templateUrl: './file-manager-alert.component.html',
  styleUrls: ['./file-manager-alert.component.scss']
})
export class FileManagerAlertComponent implements OnInit {
  @Input() parentData: any;

  constructor(private fb: FormBuilder,
              public activeModal: NgbActiveModal) {
  }

  form: FormGroup;

  ngOnInit(): void {
    this.form = this.fb.group({
      id: [this.parentData.id || null],
      codeImg: [this.parentData['modal'].codeImg || null],
      img: [this.parentData.img || null],
      img64: [this.parentData.img || null],
      img64Upload: [this.parentData && this.parentData.img ? false : null],
      orderId: [this.parentData.orderId || null],
      status: [(this.parentData && this.parentData.status ? (this.parentData.status === 'Activo' ? 1 : 0) : null)],
      title: [this.parentData.title || ''],
      subTitle: [this.parentData.subTitle || ''],
      name: [this.parentData.name || null],
      url: [this.parentData.url || null]
    });
  }

}
